module.exports = __webpack_public_path__ + "img/default-google-maps-backup-bg.e168dbf1.png";